import React from 'react';

const Resume = () => {
  return (
    <>
      <section id="resume-work-experience" className="text-center py-2">
        <div className="container">
          <h2>Work Experience</h2>
          <div className="cols cols-two">
            <div>
              <h3>Lead UX Designer and Brand Specialist</h3>
              Combination Göteborg
              <br />
              2016 – 2020
            </div>
            <div>
              <p>
                Leading the UX design for online sports betting, and driving
                employer branding for a small tech company in the betting and
                casino industry.
              </p>
              <ul>
                <li>UX/UI Design</li>
                <li>Prototyping</li>
                <li>User Research</li>
                <li>Frontend development</li>
                <li>Business Analysis</li>
                <li>Employer Branding</li>
              </ul>
            </div>
          </div>

          <div className="cols cols-two">
            <div>
              <h3>Lead UX Designer and Business Analyst</h3>
              Capgemini Stockholm, Göteborg
              <br /> 2009 – 2015
            </div>
            <div>
              <p>
                Consulting shorter and longer assignments within UX and adjacent
                capacities at large global consultancy.
              </p>
              <ul>
                <li>UX design</li>
                <li>Strategy</li>
                <li>Business Analysis</li>
                <li>Training and Mentoring</li>
                <li>Frontend development</li>
                <li>Workshop Facilitation</li>
                <li>Project Management </li>
              </ul>
            </div>
          </div>

          <div className="cols cols-two">
            <div>
              <h3>Lead Frontend Developer and Usability Specialist</h3>
              Pricerunner, Stockholm
              <br /> 2007 – 2008
            </div>
            <div>
              <p>
                Responsible for Frontend code and framework, for mid-size
                company.
              </p>
              <ul>
                <li>Frontend development</li>
                <li>Accessibility</li>
                <li>Usability</li>
                <li>UXdesign</li>
                <li>SEO</li>
              </ul>
            </div>
          </div>

          <div className="cols cols-two">
            <div>
              <h3>Frontend Developer and Usability Specialist</h3>
              Svenska Mässan, Göteborg <br />
              2000 – 2007
            </div>
            <div>
              <p>
                Development of web interfaces and interaction design for public
                websites and intranet at mid-size company.
              </p>
              <ul>
                <li>Frontend development</li>
                <li>Usability</li>
                <li>Accessibility</li>
                <li>UXDesign</li>
                <li>SEO</li>
                <li>Business analysis</li>
              </ul>
            </div>
          </div>

          <div className="cols cols-two">
            <div>
              <h3>Frontend Developer</h3>
              Freelance, Göteborg <br />
              1998 – 2000
            </div>
            <div>
              <p>
                Website production and Frontend development on a freelance basis
              </p>
              <ul>
                <li>Frontend development</li>
                <li>UX Design</li>
                <li>Graphic Design</li>
                <li>Content creation</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      <section id="resume-skills" className="text-center py-2">
        <div className="container">
          <h2>Skills</h2>
          <div>
            <img
              src="img/swiss-army-knife.png"
              alt="Swiss army knife: UX Design, Frontend Development, Strategy, Service Design, Business Analysis, Training, Workshop Facilitation"
            />
          </div>
        </div>
      </section>

      <section id="resume-side-gig" className="text-center py-2">
        <div className="container">
          <h2>Side gig</h2>
          <div className="cols cols-two">
            <div>
              <h3>Voice Actor</h3>
              Los Angeles/Göteborg/Stockholm <br />
              1994 – Present
            </div>
            <div>
              <p>
                Voice acting, and occasional on-screen acting for an
                international market. Copywriting, proofreading and translation.
                Marketing and Management of a small business with international
                clients.
              </p>
              <ul>
                <li>Voice Acting</li>
                <li>On-camera acting</li>
                <li>Screen writing</li>
                <li>Marketing</li>
                <li>Small business management</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      <section id="resume-industry-experience" className="text-center py-2">
        <div className="container">
          <h2>Industry experience</h2>

          <div className="cols cols-three">
            <div>
              <i className="fas fa-industry fa-2x"></i>
              <br /> Manufacturing
            </div>
            <div>
              <i className="fas fa-landmark fa-2x"></i>
              <br />
              Public sector
            </div>
            <div>
              <i className="fas fa-car fa-2x"></i>
              <br />
              Automotive
            </div>
          </div>
          <div className="cols cols-three">
            <div>
              <i className="fas fa-dice fa-2x"></i>
              <br />
              Gaming
            </div>
            <div>
              <i className="fas fa-film fa-2x"></i>
              <br />
              Media
            </div>
            <div>
              <i className="fas fa-briefcase-medical fa-2x"></i> <br />
              Medical
            </div>
          </div>

          <div className="cols cols-three">
            <div>
              <i className="fas fa-piggy-bank fa-2x"></i>
              <br />
              Finance
            </div>
            <div>
              <i className="fas fa-shipping-fast fa-2x"></i>
              <br />
              Logistics
            </div>
            <div>
              <i className="fas fa-bus-alt fa-2x"></i> <br />
              Transportation
            </div>
          </div>
        </div>
      </section>

      <section id="resume-education" className="py-2">
        <div className="container">
          <div className="cols cols-two">
            <div>
              <h2>Higher Education</h2>
              <p>(Relevant selection)</p>
              <h3>Human Computer Interaction </h3>
              Freestanding Course
              <br />
              University West, Sweden 2007
              <h3>Frontend Development, Digital Design and Marketing</h3>
              Vocational Program <br />
              Handelsakademin, Göteborg , Sweden 1998-1999
              <h3>Linguistics and Intercultural Communication </h3>
              University Diploma
              <br />
              Göteborg University, Sweden 1992-1997
            </div>
            <div>
              <h2>Courses</h2>
              <p>(Relevant selection)</p>
              <h3>Modern HTML, CSS & Sass </h3>
              Udemy 2020-2021
              <h3>Facilitating Essentials</h3> Capgemini University, Göteborg ,
              Sweden 2013
              <h3>Rapid Design and Visualization </h3>
              Capgemini University, France 2010
              <h3>Software Engineering Immersion </h3>
              Capgemini University, France 2010
            </div>
          </div>
        </div>
      </section>

      <section id="resume-spare-time" className="text-center py-2">
        <div className="container">
          <h2>Spare time</h2>
          <div className="cols cols-three">
            <div>
              <i className="fas fa-dumbbell fa-2x"></i>
              <br /> Lifting things
            </div>
            <div>
              <i className="fas fa-swimmer fa-2x"></i>
              <br />
              Being in the water
            </div>
            <div>
              <i className="fas fa-book-open fa-2x"></i>
              <br />
              Reading
            </div>
          </div>
          <div className="cols cols-three">
            <div>
              <i className="fas fa-hand-rock fa-2x"></i>
              <br />
              Swinging at things
            </div>
            <div>
              <i className="fas fa-pepper-hot fa-2x"></i>
              <br />
              International Cooking
            </div>
            <div>
              <i className="fas fa-laptop fa-2x"></i> <br />
              Writing
            </div>
          </div>
        </div>
      </section>

      <section id="resume-personal-motto" className="text-center py-2">
        <div className="container">
          <h2>Personal motto</h2>
          <blockquote>
            “I would rather go for extraordinary and fail, than mediocre and
            succeed.”
          </blockquote>
        </div>
      </section>
    </>
  );
};

export default Resume;
